module.exports = "/assets/data/59faa0ba2d8c9ddcb2719a0b57f9af28-WF9.data.json";